import styled from 'styled-components';
import { Button } from '@sainsburys-tech/bolt';
import { TwoManDeliveryIcon } from '@sainsburys-tech/bolt-icons';
var StyledContainer = styled.div.withConfig({
  displayName: "WantItDeliveredstyles__StyledContainer",
  componentId: "sc-1jdrwnn-0"
})(["border-top:1px solid ", ";background:", ";position:relative;bottom:0;left:0;width:100%;box-shadow:0 0 4px 0 rgba(0,0,0,0.46);@media screen and (min-width:", "){position:absolute;}"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var StyledTwoManDeliveryIcon = styled(TwoManDeliveryIcon).withConfig({
  displayName: "WantItDeliveredstyles__StyledTwoManDeliveryIcon",
  componentId: "sc-1jdrwnn-1"
})(["display:inline-block;height:20px;width:20px;position:relative;top:0;left:-8px;vertical-align:top;&&&{fill:", ";}"], function (props) {
  return props.theme.color.palette['brand-1'];
});
var StyledButton = styled(Button).withConfig({
  displayName: "WantItDeliveredstyles__StyledButton",
  componentId: "sc-1jdrwnn-2"
})(["border:0;padding:15px;text-decoration:none;"]);
export { StyledContainer, StyledTwoManDeliveryIcon, StyledButton };